export default __webpack_public_path__ + "static/media/Enroll.46c69b36.svg";